import { useForm, FormProvider } from 'react-hook-form';
import JobDescriptionDetailContent from '@/components/company/job/JobDescriptionDetailContent';
import { IJobDescription } from '@/states/job.state';

export default function JobDescriptionDetail() {
  const formControl = useForm<IJobDescription>({ defaultValues: { name: '' } });

  return (
    <FormProvider {...formControl}>
      <JobDescriptionDetailContent />
    </FormProvider>
  );
}
